import { type ColumnDef, createColumnHelper } from '@tanstack/react-table';
import Tippy from '@tippyjs/react';
import TableTag from '../TableTag';
import { type AssetWithTagsResponse } from 'interfaces/assets/Asset.interface';
import { useTranslation } from 'react-i18next';

interface AnomaliesTableColumnsReturnType {
  columns: ColumnDef<any, any>[];
}

const useGetOrganizationBuildingsAttentionColumns =
  (): AnomaliesTableColumnsReturnType => {
    const { t } = useTranslation();
    const columnHelper = createColumnHelper<AssetWithTagsResponse>();

    const columns = [
      columnHelper.accessor('name', {
        header: () => t('organizationView.buildingsWithTags.columns.name'),
        cell: (info) => {
          return (
            <Tippy content={info.getValue()} maxWidth={450}>
              <span className="flex items-center gap-2.5">
                <span className="block text-ellipsis overflow-hidden truncate">
                  {info.renderValue()}
                </span>
              </span>
            </Tippy>
          );
        },
        enableSorting: true,
        size: 150,
        maxSize: 200,
      }),
      columnHelper.accessor('location', {
        header: () => t('organizationView.buildingsWithTags.columns.location'),
        cell: (info) => {
          return (
            <Tippy content={info.getValue()} maxWidth={450}>
              <span className="flex items-center gap-2.5">
                <span className="block text-ellipsis overflow-hidden truncate">
                  {info.renderValue()}
                </span>
              </span>
            </Tippy>
          );
        },
        enableSorting: true,
        size: 100,
        maxSize: 100,
      }),
      columnHelper.accessor('function', {
        header: () => t('organizationView.buildingsWithTags.columns.function'),
        cell: (info) => {
          return (
            <Tippy content={info.getValue()} maxWidth={450}>
              <span className="flex items-center gap-2.5">
                <span className=" block text-ellipsis overflow-hidden truncate">
                  {info.renderValue()}
                </span>
              </span>
            </Tippy>
          );
        },
        enableSorting: true,
        size: 100,
        maxSize: 100,
      }),
      columnHelper.accessor('tags', {
        header: () => t('organizationView.buildingsWithTags.columns.tags'),
        cell: (info) => {
          const values = info.row.original;
          const tags = values.tags;
          return (
            <div className="flex w-full min-w-[300px] max-w-[600px] flex-wrap gap-1">
              {tags?.map((tag, index) => {
                return <TableTag key={`${tag.tag}${index}`} name={tag.tag} />;
              })}
            </div>
          );
        },
        enableSorting: true,
        size: 450,
        maxSize: 600,
      }),
    ];

    return {
      columns,
    };
  };
export default useGetOrganizationBuildingsAttentionColumns;
